const router = [
  {
    path: "/carbon/footprint",
    name: "CarbonFootprint",
    component: () => import("@/views/index/CarbonFootprint.vue"),
    meta: {
      title: "碳足迹",
      bottomSafeAreaClass: "bg-page-gray",
    },
  },
];
export default router;
